export default __webpack_public_path__ + "static/solution-ona-728634c325d4da195beef8394db33abb.webm";